import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ProductReview = () => {
  const { user_id, order_id, product_id } = useParams();

  const [order, setOrder] = useState(null);
  const [product, setProduct] = useState(null);

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [review, setReview] = useState({ message: "" });
  const [images, setImages] = useState([]);

  const navigate = useNavigate();

  // 🔹 Fetch Orders (API returns list)
  const fetchOrder = async () => {
  try {
    const res = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_order",
      { user_id }
    );

    if (res.data.status) {
      const foundOrder = res.data.data.find(
        (o) => String(o.order_id) === String(order_id)
      );

      if (!foundOrder) {
        toast.error("Order not found");
        return;
      }

      const foundProduct = foundOrder.items.find(
        (p) => String(p.product_id) === String(product_id)
      );

      if (!foundProduct) {
        toast.error("Product not found in order");
        return;
      }

      setOrder(foundOrder);
      setProduct(foundProduct);
    }
  } catch (err) {
    toast.error("Failed to fetch order");
  }
};


  // 🔹 Fetch Product
  const fetchProduct = async (product_id) => {
    try {
      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
        { product_id }
      );

      if (res.data.status) {
        setProduct(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch product");
    }
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  // 🔹 Submit Review
  const handleSubmit = async () => {
  if (!rating || !review.message) {
    toast.warning("Please provide rating and review");
    return;
  }

  const formData = new FormData();

  formData.append("product_id", product.product_id);
  formData.append("product_name", product.product_name);
  formData.append("seller_id", product.seller_id);
  formData.append("order_id", order.order_id);
  formData.append("user_id", user_id);
  formData.append("rating", rating);
  formData.append("your_review", review.message);

  images.forEach((img) => {
    formData.append("image[]", img);
  });

  try {
    const res = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_review",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("Review API Response:", res.data);

    // SUCCESS
    if (res.data?.status === true) {
      toast.success(
        res.data?.message || "Review submitted successfully"
      );

     navigate("/order");

    } 
    // FAILED
    else {
      toast.error(
        res.data?.message || "Review submission failed"
      );
    }

  } catch (error) {
    console.log("Review Submit Error:", error);

    toast.error(
      error?.response?.data?.message ||
      "Something went wrong"
    );
  }
};


  return (
    <div className="container reviewpage">
      <div className="card p-4">

        <h4 className="mb-3">Rate & Review Product</h4>

        {product && (
        <div className="d-flex align-items-center mb-4">
          <img
            src={
              product.multi_image
                ? `https://cyberathon.com/multivendor/${product.multi_image}`
                : "https://via.placeholder.com/80"
            }
            className="rounded border me-3"
            width={80}
            height={80}
          />
          <div>
            <h6>{product.product_name}</h6>
            <small className="text-muted">
              Order ID: {order.order_number}
            </small>
          </div>
        </div>
)}


        {/* Rating */}
        <div className="mb-3">
          {[...Array(5)].map((_, i) => {
            const val = i + 1;
            return (
              <FaStar
                key={val}
                size={26}
                color={val <= (hover || rating) ? "#ffc107" : "#ddd"}
                onClick={() => setRating(val)}
                onMouseEnter={() => setHover(val)}
                onMouseLeave={() => setHover(0)}
              />
            );
          })}
        </div>

        {/* Review */}
        <textarea
          className="form-control mb-3"
          rows="4"
          placeholder="Write your experience about the product..."
          onChange={(e) => setReview({ message: e.target.value })}
        />

        <input
          type="file"
          multiple
          className="form-control mb-4"
          onChange={(e) => setImages([...e.target.files])}
        />

        <div className="text-center">
          <button className="button3" onClick={handleSubmit}>
            Submit Review
          </button>
        </div>

      </div>
    </div>
  );
};

export default ProductReview;
